import { Injectable } from '@angular/core';

import { AuthenticationService } from '@tt-chvac/authentication';

import { RoleService, UserInfoService } from '@tt-chvac/core-sales-web';
import { environment } from './../environments/environment';

@Injectable()
export class UserInfoResolver  {
    constructor(private authenticationService: AuthenticationService,
        private userInfoService: UserInfoService,
        private roleService: RoleService
    ) { }

    resolve() {
        // return the logged in user details to the JobsListMasterModule so that all the components
        // in the module will have access to it before they are initialised.
        return this.authenticationService.getUser().then((user) => {
            // if the user is returned as null/undefined log off the user and redirect to
            // login else return the user claims
            if (!user) {
                this.authenticationService.logout();
            } else {
                const userId = user.samAccountName;
                const userName = user.givenName + ' (' + userId + ')';
                const userFullName = user.name;
                const userRoles = user.groups;
                // Storing the logged user information into library service,
                // So that it be can accessible the user information values across the multiple libraries.
                // To reduce the Azure calls
                this.userInfoService.setUserId(userId);
                this.userInfoService.setUserName(userName);
                this.userInfoService.setFullName(userFullName);
                this.userInfoService.setUserRoles(userRoles);
                this.userInfoService.setEmail(user.email);

                // TODO: Need to replace with entitlement api
                // TODO: Selva
                // Checks the access permission of the user in prod & non-prod environments
                if (userRoles && Array.isArray(userRoles) && userRoles.length > 0) {
                    this.roleService.checkUserRoles(environment.deployedEnv.toLowerCase() === 'production', userRoles);
                }

                // Sets isProdEnvironment variable in role service
                this.roleService.setProdEnvironment(environment.deployedEnv.toLowerCase() === 'production');

                return user;
            }
        });
    }
}
